import React, { useEffect, useState } from "react";
import PageLoading from "../../helpers/PageLoading";
import { useHistory, useParams } from "react-router";
import { connect } from "react-redux";
import { DndProvider } from "react-dnd";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import {
  currencyValues,
  getDuration,
  getError,
} from "../../store/helpers/common_functions";
import moment from "moment";
import {
  Box,
  Button,
  Chip,
  LinearProgress,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import a11yProps from "../../helpers/ay-props";
import TabPanel from "../../helpers/TabPanel";
import ProjectDeliverable from "../../components/Project/ProjectActivities";
import ProjectAssignment from "../../components/Project/ProjectAssignment";
import ProjectAttachment from "../../components/Project/ProjectAttachment";
import { StyledTableRow } from "../../helpers/CustomMenu";
import { BorderColor, Delete, Edit, PermDeviceInformationTwoTone } from "@mui/icons-material";
import DeleteDialog from "../../helpers/DeleteDialog";
import FormDialog from "../../helpers/FormDialog";
import HistoryComponent from "components/HistoryComponent";
import WorklogManager from "./WorklogManager";
import StatusLayout from "components/Status";
import { FaArrowLeft, FaBackspace, FaClock, FaLevelDownAlt, FaLevelUpAlt, FaMoneyBillWave, FaUserCog } from "react-icons/fa";
import FunderAssignment from "components/Funder/FunderAssignment";
import PartnerAssegnment from "components/Partner/PartnerAssegnment";
import ProjectReportDetails from "./ProjectReportDetails";
import { getMyLineManager } from "../../helpers/Common_functions";



function ProjectDetails({
  FetchDetails,
  PutAction,
  GetAllMeetingList,
  meetingList,
  loggedUser,
  location,
  SetSelectedMenu,
  systemSettings
}) {
  const mainBackground = systemSettings?.mainBackground;

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState();
  const [info, setInfo] = React.useState();
  const [tabValue, setTabValue] = React.useState(0);
  const [manualsDev, setManualsDev] = React.useState();
  const [manualsDevOps, setManualsDevOps] = React.useState();
  const [value, setValue] = useState({});
  const [deleteOpen, setDeleteOpen] = useState(0);
  const [resumeOpen, setResumeOpen] = useState(0);
  const [open, setOpen] = useState(0);
  const [openExtend, setOpenExtend] = useState(0);
  const [funders, setFunders] = useState([]);
  const [partners, setPartners] = useState([]);
  const [id, setId] = useState(useParams().id);
  const [totalAmount, setTotalAmount] = useState(0);
  const [status, setStatus] = React.useState(info?.project?.status);
  const [progress, setProgress] = React.useState(false);
  const program = location.state?.program;
  const [descriptionDialogOpen, setDescriptionDialogOpen] = useState(false);
  const [myLineManager, setMyLineManager] = useState([]);
  const [projectInitiator, setProjectInitiator] = useState({});


  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  const hasDeliverable = info?.deliverables?.length > 0;
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    const getmyReportingLine = async () => {
      const myLineManager = await getMyLineManager(loggedUser);
      if (myLineManager) {
        setMyLineManager(myLineManager);
      }
    };
    getmyReportingLine();
  }, [loggedUser]);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    const resp = await FetchDetails(`/api/project/details/${id}`);
    const manualsDoc = await FetchDetails(`/api/home/documents`);
    setLoading(false);
    if (manualsDoc.status) {
      setManualsDev(
        manualsDoc.data?.filter((item) => item?.type === "developers")
      );
      setManualsDevOps(
        manualsDoc.data?.filter((item) => item?.type === "devops")
      );
    }
    if (resp.status) {
      // if (info) {
      // if (!hasDeliverable && resp.data.deliverables.length) {
      //   setTabValue((v) => v - 1);
      // } else if (hasDeliverable && !resp.data.deliverables.length) {
      //   setTabValue((v) => v + 1);
      // }
      // }

      setId(id);
      setInfo(resp.data);
      setProjectInitiator(resp.data?.project?.projectInitiator);

      SetSelectedMenu({
        menu: "program",
        title: `Project Management > ${resp.data?.project?.name}`,
      });

      const fetchFunders = await FetchDetails(`/api/funder/assigned?projectId=${id}`);
      const fetchPartners = await FetchDetails(`/api/partner/assigned?projectId=${id}`);
      if (fetchFunders.status) {
        setFunders(fetchFunders.data.data);
      }
      if (fetchPartners.status) {
        setPartners(fetchPartners.data.data);
      }
      setTotalAmount(resp.data?.project?.budgetType === 'restricted' ? resp.data?.project?.budget : resp.data?.totalAllocatedBudget);
    } else {
      setError(getError(resp));
    }
    return resp;
  };

  useEffect(() => {
    loadData().then();
  }, [id]);


  useEffect(() => {
    const query = `projectId=${id}`;
    GetAllMeetingList(query);
  }, []);



  const nIndex = hasDeliverable ? 0 : 1;

  const history = useHistory();

  const initiator = info?.project?.initiator === loggedUser?.Resource?.id;
  // const supervisor = info?.assignees.find((v) => v.role === "supervisor");
  // const isSupervisor = supervisor?.Resource?.id === loggedUser?.Resource?.id;
  // const canEdit = isSupervisor || initiator || loggedUser?.allowAllProject;
  const canEdit = loggedUser?.allowProject;

  const budget =
    info?.project?.budgetType === 'restricted'
      ? info?.project?.budget?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0
      : info?.totalAllocatedBudget?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0;

  const usedBudget =
    (info?.totalAllocatedPartner)?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0;


  return (loading && !info) || error || !info ? (
    <PageLoading error={loading ? null : error} onRefresh={loadData} />
  ) : (
    <div className={"flex flex-wrap"}>
      <FormDialog
        maxWidth={"md"}
        col={6}
        open={open > 0}
        onSuccess={loadData}
        setOpen={setOpen}
        url={`/api/project/update/${info.project.id}`}
        title={"Edit Project"}
        fields={[
          {
            name: "name",
            label: "Project name",
            value: value["name"],
            required: true,
            col: 12,
            setValue: (val) => setValue0("name", val),
          },
          {
            name: "startDate",
            label: "Start Date",
            type: "date",
            value: value["startDate"],
            required: true,
            // hidden: info.project.status === 'overdue',
            setValue: (val) => setValue0("startDate", val),
          },
          {
            name: "endDate",
            label: "End Date",
            type: "date",
            value: value["endDate"],
            required: true,
            // hidden: !info.project.status === 'overdue',
            setValue: (val) => setValue0("endDate", val),
          },
          {
            name: "extendedFrom",
            label: "Extended From",
            type: "date",
            value: value["extendedFrom"],
            // required: true,
            hidden: !info.project?.extendedFrom,
            setValue: (val) => setValue0("extendedFrom", val),
          },
          {
            name: "extendedTo",
            label: "Extended To",
            type: "date",
            value: value["extendedTo"],
            // required: true,
            hidden: !info.project?.extendedFrom,
            setValue: (val) => setValue0("extendedTo", val),
          },
          {
            name: "supportStart",
            label: "Support Start From",
            type: "date",
            value: value["supportStart"],
            // required: true,
            hidden: !info.project?.supportStart,
            setValue: (val) => setValue0("supportStart", val),
          },
          {
            name: "supportTo",
            label: "Support Start To",
            type: "date",
            value: value["supportTo"],
            // required: true,
            hidden: !info.project?.supportStart,
            setValue: (val) => setValue0("supportTo", val),
          },
          {
            name: "client",
            label: "Client",
            value: value["client"],
            required: true,
            setValue: (val) => setValue0("client", val),
          },
          {
            name: "contractType",
            label: "Contract Type",
            type: "select",
            values: [
              { label: "Lumpsum", value: "lumpsum" },
              { label: "Framework", value: "framework" },
            ],
            value: value["contractType"],
            required: true,
            setValue: (val) => setValue0("contractType", val),
          },
          {
            name: "budgetAmount",
            label: "Budget",
            type: "number",
            value: value["budgetAmount"],
            required: true,
            setValue: (val) => setValue0("budgetAmount", val),
          },
          {
            name: "amountType",
            label: "Currency Type",
            type: "select",
            values: currencyValues,
            value: value["amountType"],
            required: true,
            setValue: (val) => setValue0("amountType", val),
          },
          {
            name: "paidAmount",
            label: "Pre Paid Amount",
            type: "number",
            value: value["paidAmount"],
            // required:true,
            setValue: (val) => setValue0("paidAmount", val),
          },
          {
            name: "termsOfReference",
            label: "Terms Of Reference",
            type: "file-drag",
            multiple: true,
            accept: ["PDF"],
            value: value["termsOfReference"],
            required: false,
            setValue: (val) => setValue0("termsOfReference", val),
          },
          {
            name: "description",
            label: "Project Description",
            value: value["description"],
            required: false,
            type: "editor",
            col: 12,
            setValue: (val) => setValue0("description", val),
          },
        ]}
      />
      {/* //extenation */}
      <FormDialog

        maxWidth={"md"}
        col={6}
        open={openExtend > 0}
        onSuccess={loadData}
        setOpen={setOpenExtend}
        url={`/api/project/update/${info.project.id}`}
        title={status === "in-support" ? "In Support" : "Extended Project"}
        fields={[
          {
            name: "name",
            label: "Project name",
            value: value["name"],
            // required: true,
            col: 12,
            setValue: (val) => setValue0("name", val),
          },

          {
            name: "extendedFrom",
            label: "Extended From",
            type: "date",
            value: value["extendedFrom"],
            // required: status !== 'in-support',
            setValue: (val) => setValue0("extendedFrom", val),
            hidden: status === "in-support",
          },
          {
            name: "extendedTo",
            label: "Extended To",
            type: "date",
            value: value["extendedTo"],
            // required: status !== 'in-support',
            setValue: (val) => setValue0("extendedTo", val),
            hidden: status === "in-support",
          },
          {
            name: "supportStart",
            label: "Support Start From",
            type: "date",
            value: value["supportStart"],
            // required: status === 'in-support',
            setValue: (val) => setValue0("supportStart", val),
            hidden: status !== "in-support",
          },
          {
            name: "supportTo",
            label: "Support Start To",
            type: "date",
            value: value["supportTo"],
            // required: status === 'in-support',
            setValue: (val) => setValue0("supportTo", val),
            hidden: status !== "in-support",
          },
          {
            name: "status",
            label: "Status",
            value: status === "in-support" ? "in-support" : "extended",
            hidden: true,
          },
          {
            name: "termsOfReference",
            label: "Terms Of Reference",
            type: "file-drag",
            multiple: true,
            accept: ["PDF"],
            value: value["termsOfReference"],
            hidden: true,
          },
        ]}
      />
      <DeleteDialog
        open={deleteOpen > 0}
        setOpen={() => {
          setDeleteOpen(0);
        }}
        onSuccess={deleteOpen === 2 ? loadData : history.goBack}
        body={{
          id: info.project.id,
          status,
        }}
        info={deleteOpen === 2}
        buttonTitle={deleteOpen === 2 ? status : "Delete"}
        title={deleteOpen === 2 ? `Add Project:${status}  !` : "Delete Project"}
        alertMessage={
          deleteOpen === 1
            ? "This project will be permanently deleted. Please ensure that you have informed all assignees."
            : null
        }
        url={
          deleteOpen === 1
            ? `/api/project/delete/${info.project.id}`
            : status !== "completed"
              ? `/api/project/hold/${id}`
              : `/api/project/complete/${id}`
        }
      />

      <DeleteDialog
        open={progress}
        setOpen={() => {
          setProgress(false);
        }}
        onSuccess={async () => {
          await loadData();
        }}
        info={true}
        title={"Progress Status"}
        bodyText={
          <div className={"py-3 text-left"}>
            <FormControl fullWidth={true} size={"small"}>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={status}
                label="Status"
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value={"incoming"}>incoming</MenuItem>

                <MenuItem value={'in-progress'}>In Progress</MenuItem>
                <MenuItem value={'to-verify'}>Under Review</MenuItem>
                <MenuItem value={'on-hold'}>On Hold</MenuItem>
                <MenuItem value={'completed'}>Completed</MenuItem>

              </Select>

            </FormControl>
          </div>
        }
        url={`/api/project/change-status/${info?.project?.id}?status=${status}`}
      />

      <DeleteDialog
        open={resumeOpen > 0}
        setOpen={() => {
          setResumeOpen(0);
        }}
        onSuccess={loadData}
        info={true}
        buttonTitle={resumeOpen === 1 ? "Resume" : "On-Hold"}
        title={resumeOpen === 1 ? "Resume Project !" : "Put Project On-Hold"}
        url={`/api/project/hold/${info.project.id}`}
      />
      <div className="w-full xl:w-12/12 px-4">

        <div className="w-full">
          <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm flex flex-col gap-4">

            <div onClick={() => history.goBack()} className="text-gray-500 flex items-center gap-2">
              <FaArrowLeft />
              <span className=" font-semibold ">{info?.project?.name}</span>
            </div>
            <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm  ">
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-2 flex flex-col gap-6 justify-around">
                  <div className="">
                    <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                      <FaClock /> Project Start-End Date
                    </p>
                    <p className="font-semibold">
                      {moment(info?.project?.startDate).format("DD/MM/yyyy")} -{" "}
                      {moment(info?.project?.endDate).format("DD/MM/yyyy")}
                    </p>
                    <div>
                      <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                        <FaClock /> Project Duration
                      </p>
                      <p className="font-semibold text-[13px]">
                        {
                          getDuration(
                            info.project?.endDate,
                            info.project?.startDate
                          )

                        }
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 ">
                    <p className="font-semibold text-primary">
                      (
                      {
                        info?.project?.budgetType
                      }
                      )
                    </p>
                    <div className="flex items-center gap-2 ">
                      <div className="space-y-3">
                        <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                          <FaMoneyBillWave /> Budget
                        </p>
                        <p className="font-semibold text-[13px]">
                          {info?.project?.budgetType === 'restricted' ? info?.project?.budget?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0 : info?.totalAllocatedBudget?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0}
                        </p>
                      </div>
                      <div className="space-y-3 font-light">
                        <p className="text-gray-500 flex items-center gap-2 text-[14px]">
                          <FaMoneyBillWave /> Used
                        </p>
                        <p className="font-semibold text-[13px]">
                          {
                            (info?.totalAllocatedPartner)?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0
                          }
                        </p>
                      </div>
                      <div className="space-y-2 font-light">
                        <p className="text-gray-500 flex items-center gap-2 text-[14px]">
                          <FaMoneyBillWave /> Balance
                        </p>
                        <p className="font-semibold text-[13px]">
                          {
                            (parseInt(totalAmount ?? 0) - parseInt(info?.totalAllocatedPartner ?? 0))?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="space-y-2 flex flex-col gap-6 justify-around">
                  <div>
                    <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                      <FaLevelUpAlt /> Project Perfomance
                    </p>
                    <p className="font-semibold">
                      {
                        info?.project?.completionPercentage ? `${parseFloat(info?.project?.completionPercentage).toFixed(2)}%` : "0%"
                      }
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <div>
                      <p className="text-gray-500 font-light text-[14px]">Project Status</p>
                      <StatusLayout status={info?.project?.status == 'to-verify' ? 'under-review' : info?.project?.status} />

                    </div>
                    {/* Initiated by */}

                    <IconButton
                      onClick={() => {
                        setProgress(true);
                      }}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <Edit />
                    </IconButton>
                  </div>


                </div>

                <div className="space-y-2 flex flex-col gap-6 justify-around">
                  <div>
                    <p className="text-gray-700 font-semibold text-[14px]">Description</p>
                    <div className="text-gray-600 font-normal text-sm">
                      {info?.project?.description?.length > 100 ? (
                        <>
                          {info?.project?.description?.substring(0, 100)}...
                          <Button
                            size="small"
                            onClick={() => setDescriptionDialogOpen(true)}
                            sx={{
                              textTransform: 'none',
                              color: mainBackground,
                              '&:hover': {
                                backgroundColor: 'transparent',
                                textDecoration: 'underline'
                              }
                            }}
                          >
                            View more
                          </Button>
                        </>
                      ) : (
                        info?.project?.description
                      )}
                    </div>
                  </div>
                  <div>
                    <p className="text-gray-700 font-semibold text-[14px]">Initiated By</p>
                    <div className="text-gray-600 font-normal text-sm">
                      {loggedUser?.Resource?.id === projectInitiator?.id ? 'ME' : (projectInitiator?.names ?? 'N/A')}
                    </div>
                  </div>
                </div>


                <Dialog
                  open={descriptionDialogOpen}
                  onClose={() => setDescriptionDialogOpen(false)}
                  maxWidth="sm"
                  fullWidth
                >
                  <DialogContent>
                    <div className={"flex items-center"}>
                      <div className={"flex-grow font-bold text-lg"}>
                        <Typography variant="h6" className="mb-3">Project Description</Typography>
                      </div>
                      <IconButton onClick={
                        () => {
                          setDescriptionDialogOpen(false);
                        }
                      }>
                        <img
                          src={require("assets/icons/close.svg").default}
                          alt={"close"}
                        />
                      </IconButton>
                    </div>

                    <Typography variant="body1">
                      {info?.project?.description}
                    </Typography>
                  </DialogContent>
                </Dialog>

              </div>

            </div>
          </div>
        </div>

        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              sx={{
                "& button.Mui-selected": {
                  color: mainBackground,
                  borderBottom: `2px solid ${mainBackground}`,
                },
                " .MuiTabs-indicator": {
                  backgroundColor: mainBackground,
                },

              }}
            >
              <Tab label="Activities" {...a11yProps(nIndex + 0)} />
              <Tab label="Funders" {...a11yProps(1)} />
              <Tab label="Partners" {...a11yProps(2)} />
              <Tab label="Assigned" {...a11yProps(nIndex + 3)} />
              <Tab label="Project Documents" {...a11yProps(nIndex + 4)} />

              {/* <Tab label="Meetings" {...a11yProps(nIndex + 5)} /> */}
              <Tab label="History" {...a11yProps(nIndex + 5)} />
              <Tab label="Worklogs" {...a11yProps(nIndex + 6)} />
              {/* <Tab label="Contribution" {...a11yProps(nIndex + 8)} /> */}
              <Tab label="Report" {...a11yProps(nIndex + 7)} />
            </Tabs>
          </Box>

          <TabPanel value={tabValue} index={0}>

            <div className="flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg border-0 ">
              <div className="rounded bg-white mb-0 px-0 py-0 overflow-hidden">
                {loading ? <LinearProgress /> : null}
                <Box sx={{ width: "100%" }}>

                  <ProjectDeliverable
                    info={info}
                    funders={funders}
                    partners={partners}
                    projectId={id}
                    onSuccess={loadData}
                    onLoad={loadData}
                    canEdit={canEdit}
                  />
                </Box>
              </div>
            </div>
          </TabPanel>

          <TabPanel value={tabValue} index={3}>
            <ProjectAssignment info={info} onSuccess={loadData} />
          </TabPanel>
          <TabPanel value={tabValue} index={4}>
            <ProjectAttachment info={info} onSuccess={loadData} canEdit={canEdit} />
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <FunderAssignment project={info?.project} info={info} onLoad={loadData} />
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <PartnerAssegnment projectId={info?.project.id} info={info} onLoad={loadData} onSuccess={loadData} />
          </TabPanel>

          {/* <TabPanel value={tabValue} index={5}>
            <MeetingAttended meetingList={meetingList} />
          </TabPanel> */}
          <TabPanel value={tabValue} index={5}>
            <HistoryComponent history={info?.project?.Histories} />
          </TabPanel>
          <TabPanel value={tabValue} index={6}>
            <WorklogManager inline={true} projectId={info?.project.id} open={true} setOpen={() => false} canViewAll={canEdit} />
          </TabPanel>
          {/* <TabPanel value={tabValue} index={8} >
            <TaskReport info={info} onSuccess={loadData} />
          </TabPanel> */}
          {/* <TabPanel value={tabValue} index={9}>
                        <ProjectReportDetails category='project'/>
                        </TabPanel> */}
          <TabPanel value={tabValue} index={7}>
            <ProjectReportDetails category={'project'} budget={budget} usedBudget={usedBudget}
              completionData={info.completionData} project={info?.project} deliverables={info?.deliverables?.filter((item) => item?.status === 'completed')}
              linemanager={myLineManager}
            />
          </TabPanel>
        </Box>

      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetails);
